import { useEffect, useRef } from 'react';
// @ts-ignore - swagger-ui-react types use legacy export
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

/**
 * Renders the OpenAPI spec (/openapi.yaml) using swagger-ui-react.
 * Super admin only — accessible at /admin/api-docs.
 * Injects theme-aware CSS overrides and a dark-mode inversion filter.
 */
export function ApiDocsViewer() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Override swagger-ui styles to match dark/light theme
    const style = document.createElement('style');
    style.textContent = `
      .swagger-ui .topbar { display: none; }
      .swagger-ui { font-family: inherit; }
      .swagger-ui .info .title { color: var(--color-text-primary, #1a1a1a); }
      .swagger-ui .info p, .swagger-ui .info li { color: var(--color-text-secondary, #555); }
      .swagger-ui .opblock-tag { color: var(--color-text-primary, #1a1a1a); border-bottom-color: var(--color-border, #e5e7eb); }
      .swagger-ui .opblock { border-color: var(--color-border, #e5e7eb); }
      .swagger-ui .opblock .opblock-summary-method { font-size: 13px; }
      .swagger-ui .btn { border-radius: 6px; }
      .swagger-ui select { border-radius: 6px; }
      .swagger-ui input[type=text] { border-radius: 6px; }
      .swagger-ui textarea { border-radius: 6px; }
      .swagger-ui .model-box { background: var(--color-bg-surface, #f9fafb); }
      @media (prefers-color-scheme: dark) {
        .swagger-ui { filter: invert(88%) hue-rotate(180deg); }
        .swagger-ui img { filter: invert(100%) hue-rotate(180deg); }
      }
      .dark .swagger-ui { filter: invert(88%) hue-rotate(180deg); }
      .dark .swagger-ui img { filter: invert(100%) hue-rotate(180deg); }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  return (
    <div ref={containerRef} className="max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-theme-primary mb-4">API Documentation</h1>
      <p className="text-sm text-theme-secondary mb-6">
        Supabase Edge Functions — OpenAPI 3.0 reference
      </p>
      <div className="bg-white rounded-lg border border-default overflow-hidden">
        <SwaggerUI url="/openapi.yaml" />
      </div>
    </div>
  );
}
